import { PaidBy } from './options';

const markErrors = (formData, setFormData, fields) => {
  const errors = {};

  fields.forEach((field) => {
    errors[field] = { ...formData[field], error: true };
  });

  if (Object.keys(errors).length > 0) {
    setFormData({ ...formData, ...errors });
    return false;
  }

  return true;
};

const isBlank = (formData, field) => {
  const value = formData[field]?.value;

  return value === undefined || value === null || `${value}`.trim() === '';
};

export const validateInvoiceRequestForm = (formData, setFormData, lineItems) => {
  const missing = ['is_recurring', 'currency', 'services_description'].filter(
    (field) => isBlank(formData, field)
  );

  if (formData.is_recurring?.value === 'yes' && isBlank(formData, 'recurring_day')) {
    missing.push('recurring_day');
  }

  const hasInvalidLine = lineItems.some(
    (item) => !`${item.description || ''}`.trim()
  );

  return markErrors(formData, setFormData, missing) && !hasInvalidLine;
};

export const validateExpenseRequestForm = (formData, setFormData) => {
  const required = [
    'description',
    'expense_date',
    'invoice_number',
    'category',
    'total_amount',
    'paid_by',
  ];

  if (formData.paid_by?.value === PaidBy.yeuls) {
    required.push(
      'account_holder_name',
      'bank_name',
      'bank_branch_number',
      'bank_account_number'
    );
  }

  return markErrors(
    formData,
    setFormData,
    required.filter((field) => isBlank(formData, field))
  );
};

export const validateSupportTicketForm = (formData, setFormData) => {
  const missing = ['subject', 'description'].filter((field) =>
    isBlank(formData, field)
  );

  return markErrors(formData, setFormData, missing);
};
